<form>
	<table *ngIf="bp" class="table table-sm table-dark no-bottom-margin" [ngClass]="{ 'bp-print-view': printView}">
		<tbody>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder tborder">
				<th>Punktart</th>
				<td><wd-list name="Punktart" [(model)]="bp.type"></wd-list></td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder">
				<th>Kartierer</th>
				<td><wd-text *ngIf="canSeePersonalData()" name="Kartierer" [(model)]="bp.header.aufnahme.kartierer"></wd-text><span *ngIf="!canSeePersonalData()">–</span></td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder bborder">
				<th>Aufnahmedatum</th>
				<td><wd-date *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="bp.header.aufnahme.datum"></wd-date><span *ngIf="!canSeePersonalData()">–</span></td>
			</tr>
			<tr class="spacer-row"><td colspan="2"></td></tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder tborder">
				<th>Forstamt/Revier</th>
				<td>
					<div style="display: flex; align-items: center; gap: 4px;">
						<wd-list name="Forstamt" [(model)]="bp.header.forstamt"></wd-list>
						<span>/</span>
						<wd-list name="Revier" [(model)]="bp.header.revier"></wd-list>
					</div>
				</td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder">
				<th>Abteilung/UA/TF</th>
				<td>
					<div style="display: flex; align-items: center; gap: 4px;">
						<wd-text name="Abteilung" [(model)]="bp.header.adresse.abteilung"></wd-text>
						<wd-list name="Unterabteilung" [(model)]="bp.header.adresse.unterabteilung"></wd-list>
						<wd-text name="Teilfläche" [(model)]="bp.header.adresse.teilflaeche"></wd-text>
					</div>
				</td>
			</tr>
			<tr *ngIf="hasGemarkung()" bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder">
				<th>Gemarkung/Flur/Flst</th>
				<td>
					<div style="display: flex; align-items: center; gap: 4px;">
						<wd-text name="Gemarkung" [(model)]="bp.header.adresse.gemarkung"></wd-text>
						<wd-number name="Flur" class="text-left" [(model)]="bp.header.adresse.flur"></wd-number>
						<wd-text name="Flurstück" [(model)]="bp.header.adresse.flurstueck"></wd-text>
					</div>
				</td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder bborder">
				<th>Forstbetrieb</th>
				<td><wd-text name="Forstbetrieb" [(model)]="bp.header.forstbetrieb"></wd-text></td>
			</tr>
			<tr class="spacer-row"><td colspan="2"></td></tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder tborder">
				<th>HBF</th>
				<td><wd-text name="Hauptbodenform" [model]="hauptbodenform()"></wd-text></td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder">
				<th>FBF</th>
				<td><wd-text name="Feinbodenform" [model]="feinbodenform() + wasserformString(bp) + mesoklimaSuffix()"></wd-text></td>
			</tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder bborder">
				<th>{{humusformLabel(bp)}}</th>
				<td>
					@if (hatHumusForm(bp) && hatVegetationsformengruppe(bp)) {
						<div style="display: flex; align-items: center; gap: 4px;">
							<wd-an-list [horizontal]="false" name="Humusform" [(model)]="bp.header.humusform.aufnahmeFlaeche"></wd-an-list>
							<wd-list name="Vegetationsformengruppe" [(model)]="bp.header.vegetationsformengruppe"></wd-list>
						</div>
					}
					@else if (hatHumusForm(bp)) {
						<wd-text name="Humusform" [(model)]="bp.header.humusform.aufnahmeFlaeche.neu"></wd-text>
					}
					@else if (hatVegetationsformengruppe(bp)) {
						<wd-list name="Vegetationsformengruppe" [(model)]="bp.header.vegetationsformengruppe"></wd-list>
					}
					@else {
						-
					}
				</td>
			</tr>
			<tr class="spacer-row"><td colspan="2"></td></tr>
			<tr bpHl="Kurzprotokoll" [hldata]="bp" class="lborder rborder tborder bborder">
				<th>Bemerkungen</th>
				<td class="text-wrap">
					<wd-multiline-text name="Bemerkungen" [(model)]="bp.header.bemerkungen"></wd-multiline-text>
				</td>
			</tr>
		</tbody>
	</table>
</form>
